import React from 'react'
import { useAuth } from '@/modules/auth/context/AuthContext'
import type { SubSnapshot } from '@/modules/auth/utils/subscriptionGate'
import type { Plan } from '../types'
import { listMemberEligiblePlansForUser, getCurrentPlanForUser } from '../services/memberPlanService'

export type UseMemberPlansResult = {
  loading: boolean
  error: string | null
  plans: Plan[]
  current: Plan | null
  subscription: SubSnapshot | null
  reload: () => Promise<void>
}

export function useMemberPlans(): UseMemberPlansResult {
  const { user } = useAuth()
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)
  const [plans, setPlans] = React.useState<Plan[]>([])
  const [current, setCurrent] = React.useState<Plan | null>(null)
  const [subscription, setSubscription] = React.useState<SubSnapshot | null>(null)

  const load = React.useCallback(async () => {
    if (!user) return
    setLoading(true)
    setError(null)
    try {
      const [list, cur] = await Promise.all([
        listMemberEligiblePlansForUser(user.id),
        getCurrentPlanForUser(user.id),
      ])
      setPlans(list)
      setCurrent(cur.plan)
      setSubscription(cur.subscription || null)
    } catch (e: any) {
      setError(e?.message ?? 'Falha ao carregar planos')
    } finally {
      setLoading(false)
    }
  }, [user?.id])

  React.useEffect(() => { load() }, [load])

  return { loading, error, plans, current, subscription, reload: load }
}
